import React, { useState } from 'react';
import { Card, List, Button, Form } from "tabler-react";
import { useForm } from '../../lib/useForm'
import Select from 'react-select';
import PostObject from '../../lib/postObject';

const globeroles = [{ label: 'Shopper', value: 'Shopper' }, { label: 'Traveller', value: 'Traveller' }]

const MessageCreateModal = ({ closeMainModal, reload }) => {
  const [message, handleChange] = useForm({ message: '', answers1: '', answers2: '', answers3: '' })
  const [saveLoading, toggleSaveLoading] = useState(false)
  const [selectedRoles, setSelectedRoles] = useState()

  const saveMessage = () => {
    let newMessage = {
      message:message.message,
      targets: selectedRoles.map(r => r.value),
      answers:[message.answers1, message.answers2, message.answers3]
    }
debugger
    toggleSaveLoading(true)
    PostObject('message', newMessage).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    });
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Message</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={() => closeMainModal()}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.FieldSet>
            <Form.Input
              name='message'
              label='Message'
              placeholder=''
              value={message.message}
              onChange={handleChange}
            />

            <Form.Input
              name='answers1'
              label='answers1'
              placeholder=''
              value={message.answers1}
              onChange={handleChange}
            />

            <Form.Input
              name='answers2'
              label='answers2'
              placeholder=''
              value={message.answers2}
              onChange={handleChange}
            />

            <Form.Input
              name='answers3'
              label='answers3'
              placeholder=''
              value={message.answers3}
              onChange={handleChange}
            />

            <Form.Label>Targets: </Form.Label>
            <List.GroupItem>
              <Select
                value={selectedRoles}
                options={globeroles}
                isMulti
                placeholder="Role"
                onChange={setSelectedRoles}
              />
            </List.GroupItem>
          </Form.FieldSet>
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            type="submit"
            onClick={saveMessage}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={() => closeMainModal()}
            disabled={saveLoading}
          >
            cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  )
}

export default MessageCreateModal;